import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Theme from '@amzn/meridian/theme';
import { ThemeProvider, useTheme } from '../context/ThemeContext';
import { AuthProvider } from '../context/AuthContext';
import PageLayout from './AppLayout';
import DeliveryStationInputs from '../pages/DeliveryStationInputs';
import NotFound from '../pages/NotFound';

const ThemedApp = () => {
    const { resolvedMode } = useTheme();
    return (
        <Theme mode={resolvedMode}>
            <BrowserRouter>
                <PageLayout>
                    <Routes>
                        <Route path="/" element={<DeliveryStationInputs />} />
                        <Route path="/delivery-stations/inputs" element={<DeliveryStationInputs />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </PageLayout>
            </BrowserRouter>
        </Theme>
    );
};

const App = () => (
    <ThemeProvider>
        <AuthProvider>
            <ThemedApp />
        </AuthProvider>
    </ThemeProvider>
);

export default App;
